import React, { useState, useEffect } from "react";
import { promoURL } from "../../../App";
import { usePromotionsData } from "../../data/PromotionData";
import { useGlobalContext } from "../../data/GlobalContext";
export default function ModulesLotteryDraw({ closeModal }) {
  const { promotionsData } = usePromotionsData();
  const data = promotionsData.find(
    (promo) => promo.title === "2/30 Lottery Draw",
  );
  const { username } = useGlobalContext();
  const isLoggedIn = Boolean(username);

  // State to track input values
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");

  // Additional state for API submission messages
  const [submissionMessage, setSubmissionMessage] = useState("");
  const [submissionMessage2, setSubmissionMessage2] = useState("");
  const [showNewEntry, setShowNewEntry] = useState(false);
  const [activeDraw, setActiveDraw] = useState("");

  const drawIntervals = [
    {
      startDay: 5, // Friday (5) start day
      startHour: 12, // Starting at 12:00 PM
      endDay: 4, // Thursday (4) end day
      endHour: 16, // Ending at 4:00 PM
      drawElement: "thursday-draw",
      message: "Displaying Thursday Draw",
    },
  ];

  const isWithinInterval = (interval, now) => {
    const currentDay = now.getDay();
    const currentHour = now.getHours();

    // Check if interval stays within the same week or spans over the week-end.
    if (interval.startDay <= interval.endDay) {
      // Standard interval within the same week:
      return (
        (currentDay > interval.startDay ||
          (currentDay === interval.startDay &&
            currentHour >= interval.startHour)) &&
        (currentDay < interval.endDay ||
          (currentDay === interval.endDay && currentHour < interval.endHour))
      );
    } else {
      // Interval spanning the end of the week (e.g., Saturday to Monday):
      return (
        currentDay > interval.startDay ||
        (currentDay === interval.startDay &&
          currentHour >= interval.startHour) ||
        currentDay < interval.endDay ||
        (currentDay === interval.endDay && currentHour < interval.endHour)
      );
    }
  };

  const checkDrawDisplay = () => {
    const now = new Date();
    let displayFound = false;

    // Loop through each defined interval.
    for (let interval of drawIntervals) {
      if (isWithinInterval(interval, now)) {
        setActiveDraw(interval.drawElement);
        console.log(interval.message);
        displayFound = true;
        break; // Exit early once a matching interval is found.
      }
    }

    // If no interval matched, show the result-draw.
    if (!displayFound) {
      console.log("Outside of valid time range");
      setActiveDraw("result-draw");
    }
  };

  // useEffect runs once on mount and sets up an interval to update every minute.
  useEffect(() => {
    if (!isLoggedIn) return;

    // Initial check when the component mounts.
    checkDrawDisplay();
    const intervalId = setInterval(checkDrawDisplay, 60000);

    // Cleanup the interval on unmount.
    return () => clearInterval(intervalId);
  }, [isLoggedIn]);
  // Validate input numbers
  const isValid1 = num1 !== "" && num1 >= 1 && num1 <= 30;
  const isValid2 = num2 !== "" && num2 >= 1 && num2 <= 30;
  const isValid = isValid1 && isValid2;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isLoggedIn) return;
    const formData = new URLSearchParams();
    formData.append("cmd", "update230guess");
    formData.append("u", username);
    formData.append("number1", num1);
    formData.append("number2", num2);

    try {
      const response = await fetch(promoURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });
      const responseText = await response.text();
      let res;
      try {
        res = JSON.parse(responseText);
      } catch (error) {
        setSubmissionMessage("Error processing response.");
        setTimeout(() => {
          setSubmissionMessage("");
          setSubmissionMessage2("");
        }, 30000);
        return;
      }

      if (res.s) {
        setSubmissionMessage(res.smsg);
        setSubmissionMessage2(
          'Watch 2/30 Live Draw on FGH.FUN <a href="https://www.facebook.com/fghofficialpage">FB PAGE</a>',
        );
        setShowNewEntry(true);
        // Clear the input fields after a successful submission.
        setNum1("");
        setNum2("");
        setTimeout(() => {
          setSubmissionMessage("");
          setSubmissionMessage2("");
        }, 30000);
      } else {
        setSubmissionMessage(res.e);
        setTimeout(() => {
          setSubmissionMessage("");
          setSubmissionMessage2("");
        }, 30000);
      }
    } catch (error) {
      setSubmissionMessage("Failed to submit the request.");
      setTimeout(() => {
        setSubmissionMessage("");
        setSubmissionMessage2("");
      }, 30000);
    }
  };
  if (!isLoggedIn) {
    return null;
  }
  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>
        <div className="promotion-lottery-module-main promotion-module-main">
          <div className="lottery-asset-character">
            <img
              src="/images/promotions/promotion-assets/lottery/lottery-character-assets.webp"
              alt="Lottery Character"
            />
          </div>
          <div className="lottery-asset-ball">
            <img
              src="/images/promotions/promotion-assets/lottery/lottery-ball-assets.webp"
              alt="Lottery Ball"
            />
          </div>
          <div className="promotion-module-content">
            <img
              src="/images/promotions/promotion-assets/lottery/lottery-title-assets.webp"
              className="lottery-img-title"
              alt="Lottery Title"
            />
            <form
              id="thursday-draw"
              className={`lotter-form-container ${
                activeDraw === "thursday-draw" ? "show" : "hidden"
              }`}
              onSubmit={handleSubmit}
            >
              <div className="lottery-input-container">
                <input
                  type="number"
                  className={`lottery-input ${!isValid1 ? "error" : ""}`}
                  min="1"
                  max="30"
                  value={num1}
                  placeholder="00"
                  onInput={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setNum1("");
                    } else {
                      const number = parseInt(value, 10);
                      if (number < 1) {
                        e.target.value = 1;
                        setNum1(1);
                      } else if (number > 30) {
                        e.target.value = 30;
                        setNum1(30);
                      } else {
                        setNum1(number);
                      }
                    }
                  }}
                />
                <input
                  type="number"
                  className={`lottery-input ${!isValid2 ? "error" : ""}`}
                  min="1"
                  max="30"
                  value={num2}
                  placeholder="00"
                  onInput={(e) => {
                    const value = e.target.value;
                    if (value === "") {
                      setNum2("");
                    } else {
                      const number = parseInt(value, 10);
                      if (number < 1) {
                        e.target.value = 1;
                        setNum2(1);
                      } else if (number > 30) {
                        e.target.value = 30;
                        setNum2(30);
                      } else {
                        setNum2(number);
                      }
                    }
                  }}
                />
              </div>
              <div className="lottery-btn-container">
                <button
                  type="submit"
                  className="lottery-submit-btn"
                  disabled={!isValid}
                >
                  Submit
                </button>
              </div>
            </form>
            <form
              className={`lotter-form-container ${
                activeDraw === "result-draw" ? "show" : "hidden"
              }`}
            >
              <div className="lottery-input-container">
                <input type="number" className={`lottery-input `} disabled />
                <input type="number" className={`lottery-input `} disabled />
              </div>
              <div className="lottery-btn-container">
                <button type="submit" className="lottery-submit-btn" disabled>
                  Submit
                </button>
              </div>
            </form>
            {activeDraw === "thursday-draw" && (
              <span className="lottery-message-text">
                Input your lucky numbers from 1 to 30.
              </span>
            )}

            {activeDraw === "result-draw" && (
              <span className="lottery-message-text">
                2/30 Lottery Draw has been ended. Visit our{" "}
                <a href="https://www.facebook.com/fghofficialpage">FB Page</a>
              </span>
            )}
            <div className="submission-message-container">
              {submissionMessage && (
                <div
                  className="submission-message"
                  dangerouslySetInnerHTML={{ __html: submissionMessage }}
                />
              )}
              {submissionMessage2 && (
                <div
                  className="submission-message"
                  dangerouslySetInnerHTML={{ __html: submissionMessage2 }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
